/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const conversationMessageDataSchema = z.object({
	id: z.string(),
	role: z.string(),
	parts: z.array(z.record(z.string(), z.unknown())),
})

export type ConversationMessageDataSchema = z.infer<typeof conversationMessageDataSchema>
